module.exports = __webpack_public_path__ + "img/symbol_18.f8e4bb69.png";